import { NgModule } from '@angular/core';
import { AuditMemberListComponent } from './audit-member-list/audit-member-list.component';
import { AuditMemberDetailsComponent } from './audit-member-details/audit-member-details.component';
import { SharedModule } from '../../shared/shared.module';
import { AuditMemberListService } from '../../core/service/grid-data/grid-data-audit-member.service';


@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    AuditMemberListComponent,
    AuditMemberDetailsComponent
  ],
  exports: [
    AuditMemberListComponent,
    AuditMemberDetailsComponent
  ],
  providers: [
    AuditMemberListService
  ]
})
export class AuditMemberModule { }
